import { render, staticRenderFns } from "./Reset-Link.vue?vue&type=template&id=69da8837&scoped=true&"
import script from "./Reset-Link.vue?vue&type=script&lang=js&"
export * from "./Reset-Link.vue?vue&type=script&lang=js&"
import style0 from "./Reset-Link.vue?vue&type=style&index=0&id=69da8837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69da8837",
  null
  
)

export default component.exports